module.exports = __webpack_public_path__ + "img/img (14).6f9aa99f.jpg";